module.exports = __webpack_public_path__ + "media/images/common/linkbtn-arrow-86f780feba82b3708a546191b786357c.svg";